(() => {
  if (window.yoriaReviewStickyInitialized) return;
  window.yoriaReviewStickyInitialized = true;

  const isVisibleModal = (modal) => {
    if (!modal || modal.hidden) return false;
    const styles = window.getComputedStyle(modal);
    if (styles.display === 'none' || styles.visibility === 'hidden') return false;
    const bounds = modal.getBoundingClientRect();
    return bounds.width > 0 && bounds.height > 0;
  };

  const syncPurchaseBar = () => {
    const modalOpen = [...document.querySelectorAll('.jdgm-review-widget-modal')].some(isVisibleModal);
    document.documentElement.classList.toggle('yoria-judgeme-modal-open', modalOpen);
  };

  const observePurchaseBar = () => {
    const purchaseBarObserver = new MutationObserver(syncPurchaseBar);
    purchaseBarObserver.observe(document.body, {
      attributes: true,
      attributeFilter: ['aria-hidden', 'class', 'hidden', 'style'],
      childList: true,
      subtree: true
    });
    syncPurchaseBar();
  };

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', observePurchaseBar, { once: true });
  } else {
    observePurchaseBar();
  }
})();
